import React from "react";
import { Stack, Typography } from "@mui/material";
import { changeFor, formatValue, valueFor } from "../helpers/turnLevelMeasures";

// One measure's figure, or a dash with "Not available yet" and the story that adds it.
// In the golden set column a null means the measure does not apply (for example,
// clarification hit rate when the golden set expects no clarifications).
const MeasureValue = ({ measure, batch, goldenSet = false }) => {
  const value = batch ? valueFor(batch, measure) : null;
  if (value == null && goldenSet && batch) {
    return (
      <Typography variant="body2" color="text.secondary">
        Not applicable
      </Typography>
    );
  }
  if (value == null) {
    return (
      <Stack spacing={0.25} alignItems="flex-start">
        <Typography variant="body2">—</Typography>
        <Typography variant="caption" color="text.secondary">
          Not available yet{measure.story ? ` (${measure.story})` : ""}
        </Typography>
      </Stack>
    );
  }
  return (
    <Typography variant="body2" fontWeight={600}>
      {formatValue(measure, value)}
    </Typography>
  );
};

const TONE_COLOR = { better: "success.main", worse: "error.main", neutral: "text.secondary" };

// Test minus production, green when test is better and red when worse.
export const MeasureChange = ({ measure, production, test }) => {
  const change = changeFor(
    measure,
    production ? valueFor(production, measure) : null,
    test ? valueFor(test, measure) : null,
  );
  if (!change) return <Typography variant="body2">—</Typography>;
  return (
    <Typography variant="body2" fontWeight={600} color={TONE_COLOR[change.tone]}>
      {change.text}
    </Typography>
  );
};

export default MeasureValue;
